import React from 'react'
import { DsButtonBase, DsTypography } from '@am92/react-design-system'

interface IFeatureSelectorButtonProps {
  label: string
  value: 'child' | 'adult'
  selectedValue: 'child' | 'adult'
  onSelect: (value: 'child' | 'adult') => void
}

const FeatureSelectorButton: React.FC<IFeatureSelectorButtonProps> = props => {
  const { label, value, selectedValue, onSelect } = props

  const isSelected = selectedValue === value

  return (
    <DsButtonBase
      onClick={() => onSelect(value)}
      sx={theme => ({
        p: 'var(--ds-spacing-mild)',
        flex: 1,
        backgroundColor: isSelected
          ? 'var(--ds-colour-actionPrimary)'
          : 'var(--ds-colour-surfaceSecondary)',
        color: isSelected
          ? 'var(--ds-colour-typoOnSurface)'
          : 'var(--ds-colour-typoPrimary)',
        transition: theme.transitions.create(['background-color', 'color'], {
          easing: theme.transitions.easing.sharp
        })
      })}
    >
      <DsTypography variant='bodyBoldMedium'>{label}</DsTypography>
    </DsButtonBase>
  )
}

export default FeatureSelectorButton
